import { Div } from "@tblabs/truffle";
import { appendable } from "@tblabs/truffle/Core/appendable";


export class AccordionContent extends Div
{
    constructor(content: appendable[])
    {
        super("accordion__content");

        this.Append(
            new Div("accordion__content-inner product-accordion__content").Append(
                ...content
            )
        );
    }
}
